module.exports = __webpack_public_path__ + "img/demand-plan-bg.c6d22df9.jpg";